import type { MlMetadataFillingProposalSchema } from '@iconik-io/iconik-api/src/services/ml';

import type { MetadataFieldValuesPatched } from './metadata';

// TODO BE-4813: drop this file once the metadata filling endpoints declare
// their response schemas.

/** The spec types `field_values` as unknown; it holds the metadata form values. */
export type MetadataFillingProposalPatched = Omit<
  MlMetadataFillingProposalSchema,
  'field_values'
> & {
  field_values?: MetadataFieldValuesPatched;
};

/** What the start endpoint answers with, under either of two names. */
export type MetadataFillingStarted = {
  job_id?: string;
  id?: string;
};

/**
 * The metadata filling endpoints answer with a body, but the spec declares
 * none, so every generated `responseBody` for them is `void`. The shapes are
 * stated once here rather than at each caller.
 */
export const asMetadataFillingProposal = (
  body: unknown,
): MetadataFillingProposalPatched =>
  // biome-ignore lint/plugin: see above.
  body as MetadataFillingProposalPatched;

/** See asMetadataFillingProposal. */
export const asMetadataFillingStarted = (
  body: unknown,
): MetadataFillingStarted =>
  // biome-ignore lint/plugin: see asMetadataFillingProposal.
  body as MetadataFillingStarted;
